import _ from "./underscore.js";
import isArray from "./isArray.js";
export default function toPath(path) {
  return isArray(path) ? path : [path];
}
_.toPath = toPath;
